const $ = jQuery;

const ShareProduct = {
  init: function () {
    this.shareButton = $(".single-product-share");
    this.shareLinks = $(".single-product-share-links");
    this.setupClickListener();
    this.setupOutsideClickListener();
  },

  setupClickListener: function () {
    this.shareButton.on(
      "click",
      function (event) {
        event.preventDefault();
        this.toggleShareLinks();
      }.bind(this)
    );
  },

  setupOutsideClickListener: function () {
    $(document).on(
      "click",
      function (event) {
        if (
          !this.shareButton.is(event.target) &&
          !this.shareButton.has(event.target).length &&
          !this.shareLinks.is(event.target) &&
          !this.shareLinks.has(event.target).length
        ) {
          this.shareLinks.slideUp();
        }
      }.bind(this)
    );
  },

  toggleShareLinks: function () {
    this.shareLinks.slideToggle();
  },
};

export default ShareProduct;
